module.exports = __webpack_public_path__ + "img/jacket-back-sub-setIn-hood.673915cf.png";